import SelectOptions from "../../select-options/SelectOptions.tsx";
import {useTranslation} from "react-i18next";
import {X} from "lucide-react";

const MobilePricingCalculatorModal = (
    {setIsCalculatorModalOpen}: {setIsCalculatorModalOpen: (arg0: boolean) => void}
) => {

    const {t} = useTranslation();

    return (
        <>
            <div id="calculator-mobile" className="d-block d-md-none prices-example-mobile pt-6 pb-5">
                <button
                    className="position-absolute fs-3 cursor-pointer close-button"
                    style={{top: '10px', right:'30px', background: 'none', border: 'none'}}
                    onClick={() => setIsCalculatorModalOpen(false)}
                >
                    <X />
                </button>
                <div className="elh mb-4">{t('commission_calculator')}</div>
                <SelectOptions flex={false}
                               sectionClass={'calculator_el mb-4'}
                               sectionHeadingClass={'mx-0 text-center'}
                               mobile={true} />
            </div>
        </>
    )
}

export default MobilePricingCalculatorModal;
